import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "xmodal-inner" }
const _hoisted_3 = { class: "xmodal" }
const _hoisted_4 = { class: "xmodal-close" }
const _hoisted_5 = { class: "xmodal-body" }
const _hoisted_6 = { class: "xmodal-section comment-form-area" }
const _hoisted_7 = { class: "comment-form-input" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "xmodal-section comments-area" }
const _hoisted_10 = { class: "list-wrapper" }
const _hoisted_11 = { class: "comments" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "body" }
const _hoisted_14 = { class: "small" }

import { ref, computed, watch, onMounted } from "vue";
import { CommentModel } from "@/types/comments";
import { CertificationVM } from "@/types/certifications";
import functions from "@/use/functions";
import { $api } from "@/services/api1";


export default /*@__PURE__*/_defineComponent({
  __name: 'Comments',
  props: {
    certification: {}
  },
  emits: ["commentAdded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const certificationVM = computed<CertificationVM>(() => props.certification);

const commentsModalActive = ref<boolean>(false);

const commentData = computed<CommentModel[]>(
  () => props.certification.comments || []
);
const comments = computed<CommentModel[]>(
  () => props.certification.comments || []
);

const count = computed<number>(() => props.certification.comments.length || 0);

const comment = ref<string | null | undefined>("");

const savingChanges = ref<boolean>(false);

const expanded = ref<boolean>(false);

const isSubmitting = ref<boolean>(false);

function toggleCommentsModal() {
  commentsModalActive.value = true;
}

function closeCommentsModal() {
  commentsModalActive.value = false;
}

async function onSubmit() {
  savingChanges.value = true;

  await addComment(comment.value);
}

function resetComment() {
  comment.value = "";
}

async function addComment(comment?: string | null) {
  isSubmitting.value = true;
  const response = await $api.certifications.addComment({
    certificationId: certificationVM.value.form.id,
    appId: certificationVM.value.appId,
    loanId: certificationVM.value.loanId,
    comment: comment,
  });

  if (response === true) {
    resetComment();
    isSubmitting.value = false;
    functions.openModal("Your comment has been added!");
    emit("commentAdded");

    return true;
  } else {
    functions.openModal("Error: Comment was not saved!");
    isSubmitting.value = false;
    return false;
  }
}

watch(isSubmitting, (newValue, oldValue) => {
  savingChanges.value = newValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "xedit sc-button",
      "data-type": "comments",
      onClick: toggleCommentsModal
    }, [
      _createElementVNode("span", null, "Comments (" + _toDisplayString(count.value) + ")", 1)
    ]),
    (commentsModalActive.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "xmodal-wrapper",
          id: "comments",
          "aria-expanded": expanded.value
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value)),
                  class: "icon-up-right-and-down-left-from-center"
                }),
                _createElementVNode("span", {
                  onClick: closeCommentsModal,
                  class: "icon-x"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Comment:", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "comment",
                      placeholder: "Write a comment...",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
                      maxlength: "4000"
                    }, null, 512), [
                      [_vModelText, comment.value]
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["sc-button submit", { loading: savingChanges.value }]),
                      disabled: (comment.value || '').trim().length === 0 || savingChanges.value,
                      onClick: onSubmit
                    }, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "button-text" }, "Submit", -1)
                    ]))], 10, _hoisted_8)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", null, "Comments (" + _toDisplayString(commentData.value.length) + "):", 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentData.value, (comment) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "comment",
                          key: comment.id
                        }, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(comment.userDisplayName), 1),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(comment.comment), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(comment.createdAtFormatted), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})